// actionCreator.js

import { UPDATE_PROCESS } from "./actionType";

export const updateProcess = (title, newData) => {
  console.log("CHANGED DATA", newData);
  return {
    type: UPDATE_PROCESS,
    payload: { title, newData }
  };
};
